import { useState, createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@radix-ui/themes';

import { useGetBoardSettings } from '../hooks/useGetBoardSettings';
import Text from '../../../shared/Text';
import SectionCard from '../../../shared/SectionCard';
import { DeleteModal } from './Topics/DeleteModal.jsx';
import { EditModal } from './Topics/EditModal.jsx';
import { TopicItem } from './Topics/TopicItem.jsx';
import { TableHeader, Name } from '../shared/TableStyledComponents';

const TopicsContext = createContext();

const TopicsContent = () => {
  const { topics } = useGetBoardSettings();
  const { t } = useTranslation('edit');
  const {
    openDeleteModal,
    setOpenDeleteModal,
    openEditModal,
    setOpenEditModal,
    item,
    setItem,
  } = useContext(TopicsContext);

  return (
    <>
      <SectionCard title={t('topicsList.title')}>
        <TableHeader>
          <Name>
            <Text variant="subtitle2">{t('audiencesList.name')}</Text>
          </Name>
        </TableHeader>
        {topics.map(topic => (
          <TopicItem
            key={topic.value}
            topic={topic}
            setItem={setItem}
            setOpenEditModal={setOpenEditModal}
            setOpenDeleteModal={setOpenDeleteModal}
          />
        ))}
      </SectionCard>
      <DeleteModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        item={item}
        setItem={setItem}
      />
      <EditModal
        open={openEditModal}
        setOpen={setOpenEditModal}
        item={item}
        setItem={setItem}
      />
    </>
  );
};

export const TopicsProvider = ({ children }) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [item, setItem] = useState(null);

  return (
    <TopicsContext.Provider
      value={{
        openDeleteModal,
        setOpenDeleteModal,
        openEditModal,
        setOpenEditModal,
        item,
        setItem,
      }}
    >
      {children}
    </TopicsContext.Provider>
  );
};

export const Topics = TopicsContent;

Topics.CreateButton = function CreateTopicButton() {
  const { t } = useTranslation('edit');
  const context = useContext(TopicsContext);

  return (
    <Button
      size="3"
      variant="solid"
      onClick={() => context?.setOpenEditModal(true)}
    >
      <i className="fa-solid fa-plus" />
      {t('topicForm.create.title')}
    </Button>
  );
};
